import { redirect } from "@tanstack/react-router";
import { useAuthStore } from "@shared/store/auth";

/**
 * Guarda de ruta por permiso. Devuelve un `beforeLoad` que:
 *  - asegura sesión cargada (redirige a /login si no autenticado),
 *  - permite el acceso si el usuario tiene AL MENOS UNO de los permisos,
 *  - en caso contrario redirige a `redirectTo` (por defecto el home).
 *
 * Es la misma fuente de verdad que el menú lateral (permisos efectivos de
 * `me.permissions`), para que navegación y acceso no diverjan.
 */
export function requirePermission(perms: string[], redirectTo = "/") {
  return async () => {
    const isAuth = await useAuthStore.getState().ensureLoaded();
    if (!isAuth) {
      throw redirect({ to: "/login" });
    }
    const granted = useAuthStore.getState().me?.permissions ?? [];
    if (perms.length > 0 && !perms.some((p) => granted.includes(p))) {
      throw redirect({ to: redirectTo });
    }
  };
}

/** Devuelve true si el usuario actual tiene alguno de los permisos. */
export function hasAnyPermission(perms: string[]): boolean {
  const granted = useAuthStore.getState().me?.permissions ?? [];
  return perms.some((p) => granted.includes(p));
}
/** Guarda de ruta por rol real de INPRONEXUS. */
export function requireRole(roles: string[], redirectTo = "/") {
  return async () => {
    const isAuth = await useAuthStore.getState().ensureLoaded();
    if (!isAuth) {
      throw redirect({ to: "/login" });
    }

    const auth = useAuthStore.getState();
    if (!roles.some((role) => auth.hasRole(role))) {
      throw redirect({ to: redirectTo });
    }
  };
}

